const openRemoveFromGroupDialog = ids => ({
  type: 'PUPILS:REMOVE_FROM_GROUP_DIALOG:OPEN',
  ids
})
const closeRemoveFromGroupDialog = () => ({
  type: 'PUPILS:REMOVE_FROM_GROUP_DIALOG:CLOSE'
})

export { openRemoveFromGroupDialog, closeRemoveFromGroupDialog }
